const TaskFormMultiFieldset = React.memo(function TaskFormMultiFieldset(props){
    const {
        formItem,
        value,
        visibilityConditions,
        showLabelAsPlaceholder,
        itemKeys,
        countryId,
        onChange,
    } = props;

    const change = React.useCallback(index => val => {
        let newValue =  _.cloneDeep(value);
        newValue[index] = val;
        onChange(newValue);
    }, [onChange, value]);

    const add = React.useCallback(event => {
        event.preventDefault();
        let newValue =  _.cloneDeep(value);
        newValue.push({});
        onChange(newValue);
    }, [onChange, value]);

    const remove = React.useCallback(index => event => {
        event.preventDefault();
        let newValue =  _.cloneDeep(value);
        newValue.splice(index, 1);
        onChange(newValue);
    }, [onChange, value]);

    const isMulti = _.get(formItem, 'ProcessFormItem.is_multi', false);
    const multiMin = _.get(formItem, 'ProcessFormItem.multi_min', null);
    const multiMax = _.get(formItem, 'ProcessFormItem.multi_max', null);
    let children = [];
    _.each(value, (val, index) => {
        let buttons = [];

        if(_.size(value) > 1 && (!multiMin || _.size(value) > multiMin)){
            buttons.push(
                <button key={`btn-remove`} className={'remove-button'} onClick={remove(index)}>
                    <i className={'fa fa-minus-circle'} aria-hidden={'true'}/>
                </button>
            );
        }

        children.push(
            <TaskFormFieldset
                key={itemKeys[index]}
                index={(isMulti ? index + 1 : null)}
                value={val}
                formItem={formItem}
                items={_.get(formItem, 'children', [])}
                label={_.get(formItem, 'ProcessFormItem.label', null)}
                display={_.get(formItem, 'ProcessFormItem.display', null)}
                buttons={buttons}
                visibilityConditions={visibilityConditions}
                showLabelAsPlaceholder={showLabelAsPlaceholder}
                countryId={countryId}
                onChange={change(index)}
            />
        );

        if(index === (_.size(value) - 1) && isMulti && (!multiMax || _.size(value) < multiMax)){
            let buttonLabel = "Add New";
            if(formItem?.ProcessFormItem?.label){
                buttonLabel = `Add New ${formItem.ProcessFormItem.label}`;
            }
            children.push(
                <button key={`btn-add`} className={'add-button'} onClick={add}>
                    <i className={'fa fa-plus-circle'} aria-hidden={'true'}/>
                    <span>{buttonLabel}</span>
                </button>
            );
        }
    });

    //useRenderDebug(`TaskFormMultiFieldset|${_.get(formItem, 'ProcessFormItem.name', 'ROOT')}`, {props, change, add, remove});

    return (
        <div className={'react-task-form-multi-fieldset flex-vertical'}>
            {children}
        </div>
    );
});

TaskFormMultiFieldset.propTypes = {
    formItem: PropTypes.object,
    value: PropTypes.any,
    visibilityConditions: PropTypes.object,
    showLabelAsPlaceholder: PropTypes.bool,
    itemKeys: PropTypes.array,
    countryId: PropTypes.number,
    onChange: value => {},
};

TaskFormMultiFieldset.defaultProps = {
    formItem: {},
    value: {},
    visibilityConditions: {},
    showLabelAsPlaceholder: false,
    itemKeys: [0],
    countryId: null,
    onChange: value => {},
};
TaskFormMultiFieldset.displayName = 'TaskFormMultiFieldset';